import { ChangeDetectionStrategy, Component, computed, effect, inject, input } from '@angular/core';

import { IconsService } from '../services/icons.service';

@Component({
  selector: 'fcom-generic-icon',
  template: `
    <svg aria-hidden="true">
      <use [attr.xlink:href]="'#' + effectiveIconRef()" />
    </svg>
  `,
  styleUrls: ['./generic-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GenericIconComponent {
  private readonly iconService = inject(IconsService);

  readonly iconRef = input<string>();
  readonly url = input.required<string>();

  readonly effectiveIconRef = computed(() => this.iconRef() ?? this.url());

  constructor() {
    effect(() => {
      const url = this.url();
      if (url) {
        this.iconService.addIcon(this.effectiveIconRef(), url);
      }
    });
  }
}
